module.exports = __webpack_public_path__ + "static/img/top_btn_discord.79368c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/top_btn_discord.png
// module id = TeXf
// module chunks = 0